import { css } from '@genesislcap/web-core';
import { closeIconStyles } from '../../../styles';

export const syndicateInfoStyles = css`
  .syndicate-info-container {
    position: relative;
    display: inline-block;
  }

  .syndicate-info-link {
    color: var(--accent-fill-rest);
    cursor: pointer;
    font-size: 12px;
    text-decoration: underline;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font-family: inherit;
  }

  .syndicate-tooltip {
    position: absolute;
    right: 0;
    top: 22px;
    background: var(--neutral-layer-2);
    border: 1px solid var(--neutral-stroke-divider-rest);
    border-radius: 6px;
    min-width: 360px;
    max-width: 420px;
    z-index: 10;
    box-shadow: var(--shadow-layer-2);
    max-height: 450px;
    overflow-y: auto;
    scroll-behavior: smooth;
  }

  .syndicate-tooltip-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    border-bottom: 1px solid var(--neutral-stroke-divider-rest);
    font-weight: 600;
    font-size: 16px;
    position: sticky;
    top: 0;
    background: var(--neutral-layer-2);
    z-index: 1;
  }

  .syndicate-tooltip-header > span:first-child {
    flex: 1;
  }

  ${closeIconStyles}

  .syndicate-tooltip-body {
    padding: 10px 12px 12px 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .no-syndicate-data {
    color: var(--neutral-foreground-hint);
    font-style: italic;
    text-align: center;
    padding: 16px;
  }

  .syndicate-row {
    display: flex;
    gap: 12px;
  }

  .syndicate-role {
    color: var(--neutral-foreground-hint);
    font-size: 12px;
    min-width: 120px;
    flex-shrink: 0;
  }

  .syndicate-members {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .syndicate-member-name {
    font-size: 14px;
  }

  .syndicate-member-name.syndicate-lead-member {
    font-weight: 600;
  }

  .syndicate-member-name.bofa-member {
    color: var(--accent-fill-rest);
    font-weight: 600;
  }
`; 
